import { useMutation } from "@tanstack/react-query";
import { useAPIClient } from "render/context/APIContext";
import { useReporting } from "render/hooks/useReporting";

export function useFinishCheckInMutation() {
  const apiClient = useAPIClient();
  const { logError } = useReporting();

  return useMutation({
    mutationFn({ patientId, visitId }: { patientId: string; visitId: string }) {
      return apiClient.visit.endCheckInProcess({ patientId, visitId }).result;
    },
    onError: (error) =>
      logError(`Failed to create assign to room job: ${error}`),
  });
}
